<template>
<div>
    <page-head :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></page-head>
    <div class="content">
        <div class="search">
            <i-form ref="search" :model="query">
                <row :gutter="80">
                    <i-col span="6">
                        <form-item label="母亲姓名" prop="userName">
                            <Input v-model="query.userName" clearable placeholder="请输入母亲姓名" maxlength="10" />
                        </form-item>
                    </i-col>
                    <i-col span="6">
                        <form-item label="母亲身份证号" prop="idCardNO">
                            <Input v-model="query.idCardNO" clearable placeholder="请输入母亲身份证号" maxlength="18" />
                        </form-item>
                    </i-col>
                    <i-col span="6">
                        <form-item label="出生证明号" prop="birthCode">
                            <Input v-model="query.birthCode" clearable placeholder="请输入出生证明号" maxlength="18" />
                        </form-item>
                    </i-col>
                </row>
            </i-form>
        </div>
    </div>
    <div class="content" v-if="info">
        <div class="search">
            <Form>
                <row :gutter="80">
                    <i-col span="8">
                        <FormItem label="宝宝姓名">
                            <div class="detail">{{info.babyName}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="宝宝性别">
                            <div class="detail">{{info.babySex}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="出生地">
                            <div class="detail">{{info.birthArea}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="出生时间">
                            <div class="detail">{{info.birthTime}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="爸爸姓名">
                            <div class="detail">{{info.dadName}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="爸爸身份证号">
                            <div class="detail">{{info.dadIdCode}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="妈妈姓名">
                            <div class="detail">{{info.momName}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="妈妈身份证号">
                            <div class="detail">{{info.momIdCode}}</div>
                        </FormItem>
                    </i-col>
                </row>
            </Form>
        </div>
    </div>
</div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const {
    birthCert
} = api;
export default {
    name: "birthCert",
    components: {
        pageHead,
    },

    data() {
        return {
            query: {
                userName: "",
                idCardNO: "",
                birthCode: "",
            },
            info: undefined,
            title: "出生证明查询",
            btnList: [{
                    name: "重置",
                    type: "reset",
                },
                {
                    name: "查询",
                    type: "search",
                },
            ],
        };
    },
    methods: {
        handleBtn(type) {
            if (type == "reset") {
                this.query.userName = "";
                this.query.idCardNO = "";
                this.query.birthCode = "";

                this.$refs.search.resetFields();
            } else if (type == "search") {
                this.birthCert();
            }
        },
        async birthCert() {
            if (!this.query.userName) {
                return this.$Message.warning("请输入母亲姓名");
            }
            if (!this.query.idCardNO) {
                return this.$Message.warning("请输入母亲身份证号");
            }
            try {
                let data = {
                    idCardNO: this.query.idCardNO,
                    userName: this.query.userName,
                    birthCode: this.query.birthCode,
                };
                console.log(data);
                let res = await this.$get(birthCert, data);
                console.log(res);
                if (res.list.length > 0) {
                    this.info = res.list[0];
                } else {
                    this.info = undefined
                }

            } finally {}
            console.log(this.query);
        },
    },
    created() {},
    mounted() {},
};
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.label {
    width: 100px;
}

.time {
    width: 100%;
}
</style>
